export var valuesPlaylistTriggerKind = ["PlaylistCertificateTrigger", "PlaylistAssignToPlaylistTrigger", "PlaylistUpdateCompetenciesTrigger", "PlaylistSendMailOnAssignmentTrigger"];
/*

*/ 
//# sourceMappingURL=PlaylistTriggerKind.js.map